@if (loanSummary) {
<div class="card tpo-report-card team-card">
  <div class="card-body">
    <div class="media align-items-center">
      <div class="media-body align-self-center">
        <h4 class="team-leader m-0 text-underline">{{loanSummary.borrowerName}}</h4>
      </div>
    </div>
    <hr class="my-2">
    <div class="media align-items-center">
      <div class="media-body align-self-center">
        <h5 class="team-leader-sm m-0">{{loanSummary.streetAddress}}</h5>
        <h5 class="team-leader-sm m-0">{{loanSummary.city}}</h5>
        <p class="text-muted mb-0">Address</p>
      </div>
    </div>
    <hr class="hr-dashed my-2">
    <div class="media align-items-center">
      <div class="media-body align-self-center min-w-0">
        <h5 class="team-leader-sm m-0">{{loanSummary.loanStatusAlias ? loanSummary.loanStatusAlias :
          (loanSummary.loanStatus || "---")}}</h5>
        @if (loanSummary.subStatusName) {
        <h5 class="team-leader-sm m-0 truncate-one-line" [title]="loanSummary.subStatusName">
          {{loanSummary.subStatusName}}</h5>
        }
        <p class="text-muted mb-0">Loan Status</p>
      </div>
    </div>
    <hr class="hr-dashed my-2">
    <div class="media align-items-center">
      <div class="media-body align-self-center">
        <h5 class="team-leader-sm mt-2 m-0">{{loanSummary.loanNumber ? loanSummary.loanNumber : "---"}}</h5>
        <p class="text-muted mb-0">Loan Number</p>
      </div>
    </div>
    <hr class="hr-dashed my-2">
    <div class="media align-items-center">
      <div class="media-body align-self-center">
        <h5 class="team-leader-sm mt-2 m-0">{{loanSummary.channel ? loanSummary.channel : "---"}}</h5>
        <p class="text-muted mb-0">Channel</p>
      </div>
    </div>
    @if (showExplanationSectionForMenuStatusIcons) {
    <hr class="hr-dashed my-2">
    <div class="icon-help-collapsible">
      <button type="button" class="icon-help-header w-100" (click)="toggleIconsHelp()"
        [attr.aria-expanded]="iconsHelpOpen">
        <div class="d-flex align-items-center gap-1 min-w-0">
          <i class="pi pi-question-circle text-muted"></i>
          <span class="icon-help-title truncate-one-line">
            What Icons Below Mean...
          </span>
        </div>

        <i class="fas text-muted" style="font-size: 0.7rem;" [ngClass]="iconsHelpOpen ? 'fa-chevron-up' : 'fa-chevron-down'"></i>
      </button>

      <div class="icon-help-body" [class.open]="iconsHelpOpen">
        <div class="m-0">
          <div class="mb-2 d-flex align-items-center flex-nowrap">
            <i class="status-indicator pi pi-check-circle text-success"></i>
            <span class="ms-1" style="font-size: 11.5px;">
              No Further Action for Submission
            </span>
          </div>

          <div class="mb-2 d-flex align-items-center flex-nowrap">
            <i class="status-indicator pi pi-question-circle text-warning"></i>
            <span class="ms-1" style="font-size: 11.5px;">
              Optional for Submission
            </span>
          </div>

          <div class="d-flex align-items-center flex-nowrap">
            <i class="status-indicator pi pi-times-circle text-danger"></i>
            <span class="ms-1" style="font-size: 11.5px;">
              Required for Submission
            </span>
          </div>
        </div>
      </div>
    </div>
    }
  </div>
</div>
}
@if (!loanSummary) {
<loading-indicator [loadingMessage]="''" [includeCardClass]="false" [customHeight]="'70vh'"></loading-indicator>
}
